import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Paginacao } from "app/components/itens-orcamento/paginacao/Paginacao";
import { FiltroListarVendedores } from "app/types/comissoes/Vendedores";
import { Vendedor } from "app/types/Vendedor";
import clsx from "clsx";
import { useFormik } from "formik";
import * as R from "ramda";
import React, { useEffect, useState } from "react";


const estiloPesquisaAbaVendedores = require("./pesquisa-aba-vendedores.module.scss").default;
const estiloFormulario = require('../../../estilos/formulario.module.scss').default
const estiloBotoes = require("../../../estilos/botoes.module.scss").default;

export type DadosAbaVendedores = {
  abaVendedores: Partial<FiltroListarVendedores>;
  vendedores?: Partial<PagedMessageResponse<Vendedor>>;
  vendedoresSelecionados: Vendedor[];
}

export type PesquisaAbaVendedoresProps = {
  corSelecionada: string;
  textoSelecionado: string;
  mostrarCancelar: boolean;
  somenteLeitura: boolean
  onCancelar: () => void
  onPesquisarVendedores: (filtro: FiltroListarVendedores) => void;
  onEnviarVendedores: (vendedores: Vendedor[]) => void;
  onAlteradoDadosAbaVendedores: (dados: DadosAbaVendedores) => void
};

export const PesquisaAbaVendedores = (props: PesquisaAbaVendedoresProps & DadosAbaVendedores) => {
  const [vendedoresSelecionados, setVendedoresSelecionados] = useState<Vendedor[]>(props.vendedoresSelecionados);

  const acaoSubmit = (values) => {
    props.onPesquisarVendedores({...values, NumeroPagina: 1})
    setVendedoresSelecionados([])
  }
  const formik = useFormik({
    initialValues: { ...props.abaVendedores },
    onSubmit: acaoSubmit,
    enableReinitialize: true,
  });

  const toggleVendedorSelecionado = (vendedor: Vendedor) => {
    if (vendedoresSelecionados.some(p => p.CodigoVendedor == vendedor.CodigoVendedor)) {
      setVendedoresSelecionados(R.filter((v) => v.CodigoVendedor != vendedor.CodigoVendedor, vendedoresSelecionados));
    } else {
      setVendedoresSelecionados(vendedoresSelecionados.concat(vendedor));
    }
  };

  useEffect(() => {
    props.onAlteradoDadosAbaVendedores({
      abaVendedores: formik.values,
      vendedores: props.vendedores,
      vendedoresSelecionados
    });
  }, [formik.values, props.vendedores, vendedoresSelecionados])

  

  const formPesquisa = () => {
    const inputCodigoVendedor = <>
      <label>Código</label>
      <input
        style={{ width: "100px" }}
        name="Codigo"
        type="text"
        value={(formik.values?.Codigo) ?? ""}
        onChange={formik.handleChange}
        disabled={props.somenteLeitura}
      />
    </>

    const inputNomeVendedor = <>
      <label>Nome</label>
      <input
        style={{ width: "440px" }}
        name="Nome"
        type="text"
        value={(formik.values?.Nome) ?? ""}
        onChange={formik.handleChange}
        disabled={props.somenteLeitura}
      />
    </>

    const botaoPesquisarVendendor = <>
      <button type="submit"
        className={clsx(`no-global-button !_bg-[#409fff] ${estiloBotoes.botaoPrimario}`)}
        id="pesquisa-vendedores"
      >Pesquisar
      </button>
    </>
    
    const botaoCancelar = <>
      {props.mostrarCancelar && (
        <button type="button"
          className={clsx(`no-global-button !_bg-[#409fff] ${estiloBotoes.botaoPrimario}`)}
          onClick={() => (props.onAlteradoDadosAbaVendedores({
            abaVendedores: formik.values,
            vendedores: props.vendedores,
            vendedoresSelecionados: []
          }), props.onCancelar())}
        >
          Cancelar
        </button>
      )}
    </>

    return <form onSubmit={(e) => {
      e.preventDefault();
      formik.handleSubmit();
    }}>
      <div className={`_ml-36 _pt-8 ${estiloFormulario.formulario}`}>
        {inputCodigoVendedor}
        {inputNomeVendedor}
      </div>
      {!props.somenteLeitura &&
        <div className="_flex _gap-2 _pt-2">
          {botaoPesquisarVendendor}
          {botaoCancelar}
        </div>}
    </form>
  }

  const botaoEnviarVendedor = <div className="_my-2">
    <button
      className={clsx(`no-global-button ${estiloBotoes.botaoPrimario}`)}
      onClick={() => (props.onEnviarVendedores(vendedoresSelecionados), setVendedoresSelecionados([]))}
    >Ok
    </button>
  </div>

  const tabelaListaVendedores = <>
    <div className={`_mt-2 ${estiloPesquisaAbaVendedores.tabela}`}>
      <div>
        <div>Código</div>
        <div>Nome</div>
      </div>

      {props.vendedores?.Entities?.map((vendedor) => {
        return (
          <div
            className={
              vendedoresSelecionados.some(p => p.CodigoVendedor == vendedor.CodigoVendedor)
                ? estiloPesquisaAbaVendedores.linhaSelecionada
                : estiloPesquisaAbaVendedores.linha
            }
            style={
              vendedoresSelecionados.some(p => p.CodigoVendedor == vendedor.CodigoVendedor)
                ? {
                  backgroundColor: props.corSelecionada,
                  color: props.textoSelecionado,
                }
                : {}
            }
            onClick={() => toggleVendedorSelecionado(vendedor)}
          >
            <div>{vendedor.CodigoVendedor.toUpperCase()}</div>
            <div>{vendedor.Nome.toUpperCase()}</div>
          </div>
        );
      })}
    </div>
  </>

  const paginacaoListaVendedores = <>
    {props.vendedores?.PageCount > 1 && (
      <div className="_mt-2">
        <Paginacao
          key={props.abaVendedores.NumeroPagina}
          paginaAtual={props.abaVendedores.NumeroPagina}
          totalPaginas={props.vendedores.PageCount}
          id="PesquisaVendedor_Paginacao"
          onAlterarListaSelecionada={(numeroPagina) => {props.onPesquisarVendedores({...formik.values, NumeroPagina: numeroPagina})}}
        />
      </div>
    )}
  </>

  return (
    <>
      {formPesquisa()}

      {props.vendedores?.Entities?.length > 0 && (
        <>
          {botaoEnviarVendedor}
          {tabelaListaVendedores}
          {paginacaoListaVendedores}
          {botaoEnviarVendedor}
        </>
      )}
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};


